import React from 'react';
import { motion } from 'framer-motion';
const experiences = [{
  id: 1,
  title: 'Ultra Modern Villa',
  location: 'Mykonos, Greece',
  price: 'From €12,500/nt',
  image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=800&q=80'
}, {
  id: 2,
  title: 'Michelin Tasting',
  location: 'Tokyo, Japan',
  price: 'Priority Access',
  image: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?auto=format&fit=crop&w=800&q=80'
}, {
  id: 3,
  title: 'Ethereal Life Expedition',
  location: 'Tromsø, Norway',
  price: 'Bespoke Itinerary',
  image: 'https://images.unsplash.com/photo-1483347756197-71ef80e95f73?auto=format&fit=crop&w=800&q=80'
}];
export function FeaturedExperiences() {
  return <section className="py-6" data-id="element-28">
      <div className="px-6 mb-4 flex justify-between items-end" data-id="element-29">
        <h2 className="text-xl text-white font-light tracking-wide" data-id="element-30">
          Curated for You
        </h2>
        <button className="text-xs text-desert-dusk uppercase tracking-widest font-medium hover:text-desert-sand transition-colors" data-id="element-31">
          View All
        </button>
      </div>

      <div className="w-full overflow-x-auto hide-scrollbar snap-x snap-mandatory px-6 pb-4" data-id="element-32">
        <div className="flex gap-4 w-max" data-id="element-33">
          {experiences.map((exp, idx) => <motion.div key={exp.id} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3 + idx * 0.1,
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} whileHover={{
          scale: 1.02
        }} className="relative w-64 h-80 rounded-3xl overflow-hidden snap-center group cursor-pointer" data-id="element-34">
              <img src={exp.image} alt={exp.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-35" />
              <div className="absolute inset-0 bg-gradient-to-t from-matte-900/90 via-matte-900/20 to-transparent" data-id="element-36" />

              <div className="absolute inset-x-0 bottom-0 p-5 flex flex-col gap-2" data-id="element-37">
                <div data-id="element-38">
                  <p className="text-xs text-titanium-200 uppercase tracking-widest mb-1" data-id="element-39">
                    {exp.location}
                  </p>
                  <h3 className="text-xl text-white font-serif leading-tight" data-id="element-40">
                    {exp.title}
                  </h3>
                </div>

                <div className="flex items-center justify-between mt-2" data-id="element-41">
                  <span className="text-sm text-desert-sand font-light" data-id="element-42">
                    {exp.price}
                  </span>
                  <button className="glass-panel px-4 py-1.5 rounded-full text-xs text-white hover:bg-white/10 transition-colors" data-id="element-43">
                    Reserve
                  </button>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}